// extracted by mini-css-extract-plugin
module.exports = {"btnBg":"linear-gradient(90deg, #6D57FA 0%, #A756F9 100%)","btnText":"#fff","checkedColor":"#00d996","caretColor":"#00d996","borderColor":"#9a6bff","primaryColor":"#00d996"};